<template>
  <div>
    <TopBarBackText
      title="가이드"
      :partners-key="partnersKey"
    />
    <div class="top-54">
      <el-tabs
        v-model="selectedTab"
        stretch
      >
        <el-tab-pane
          label="iOS"
          name="ios"
        >
          <div class="guides">
            <nuxt-img
              v-for="label,index in iosImages"
              :key="index"
              class="w-full"
              style="display: block"
              :src="url(`/guides/${label}.webp`)"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="Android"
          name="aos"
        >
          <div class="guides">
            <nuxt-img
              v-for="label,index in androidImages"
              :key="index"
              class="w-full"
              :src="url(`/guides/${label}.webp`)"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
const { url } = useBlob()
const { partnersKey } = useAuthStore()
withDefaults(defineProps<{
  iosImages: ImageLabel[]
  androidImages: ImageLabel[]
}>(), {
})
const { os } = useRoute().query
const selectedTab = ref(os ? os.toString() : 'ios')
</script>
